
















































































































































interface IformData {
  username: string;
  password: string;
  fullName: string;
  phone: string;
  email: string;
  status: string;
  remark: string;
  gender: string;
  userType: string;
  roleCode: string;
  terminalType?: number;
}

import { Vue, Component, Ref, Emit } from 'vue-property-decorator';
import { setUserCreate, setUserUpdate, checkUserName, queryRoleList } from '@/utils/api';

// 前端逻辑：
// 登录账号：（前端逻辑）必填。6~30个字符，必须包含字母。可以使用大小写字母、数字、特殊符号（如?@*%.，不支持:）。全局唯一。
// 登录密码：必填。8~30个字符，必须包含大小写字母、数字、特殊符号（如?@*%.，不支持:）
// 用户姓名：（前端逻辑）必填。支持中文、英文字母、数字、特殊字符。

@Component({
  name: 'detailDrawer',
  components: {}
})
export default class DetailDrawer extends Vue {
  @Ref('formDataRef') formDataRef!: any;
  @Ref('fullNameRef') fullNameRef!: any;
  @Ref('passwordRef') passwordRef!: any;
  @Ref('usernameRef') usernameRef!: any;
  @Emit('success') submitSuccessEmit(msg?: any) {
    return msg;
  }

  title: string = '';
  loading: boolean = false;
  drawerVisible: boolean = false;

  validateStateFullName: string = 'success';
  validateStatePassword: string = 'success';
  validateStateUsername: string = 'success';

  formData: IformData = {
    username: '',
    password: '',
    fullName: '',
    phone: '',
    email: '',
    status: 'VALID',
    remark: '',
    gender: 'MALE',
    userType: 'NORMAL',
    roleCode: '',
    terminalType: 3
  };

  type: string = 'created';
  roleData: any[] = [];
  getRoleList() {
    const params = {
      tenantIds: localStorage.getItem('partnerId') || '',
      terminalType: 3
    };
    queryRoleList(params).then(res => {
      this.roleData = res;
    });
  }

  /*
   *@description:'设置 登录账号，用户密码  用户姓名 的 校验状态'
   */
  setvalidateState(prop) {
    this.$nextTick(() => {
      switch (prop) {
        case 'fullName':
          this.validateStateFullName = this.fullNameRef.validateState;
          break;
        case 'password':
          this.validateStatePassword = this.passwordRef.validateState;
          break;
        case 'username':
          this.validateStateUsername = this.usernameRef.validateState;
          break;
      }
    });
  }
  /*
   *@description:'inputBlurEvent'
   */
  inputBlurEvent(value, prop) {
    this.setvalidateState(prop);
  }
  /*
   *@description:'inputChange事件'
   */
  inputEvent(value, prop) {
    this.setvalidateState(prop);
  }
  /*
   *@description:'初始化方法'
   */
  init() {
    this.validateStateFullName = 'success';
    this.validateStatePassword = 'success';
    this.validateStateUsername = 'success';
    this.loading = false;
    debugger;
    this.getRoleList();
    this.$nextTick(() => {
      this.formData = {
        username: '',
        password: '',
        fullName: '',
        phone: '',
        email: '',
        status: 'VALID',
        remark: '',
        gender: 'MALE',
        userType: 'NORMAL',
        roleCode: '',
        terminalType: 3
      };
      this.formDataRef.resetFields();
    });
  }

  getDialogTitle(type: string): void {
    this.title = type === 'created' ? '新建用户' : '编辑用户';
  }

  deepClone(rowData) {
    return JSON.parse(JSON.stringify(rowData));
  }

  openDrawer(type: string, rowData: { ['key']: any } | undefined) {
    const { getDialogTitle, init } = this;
    this.type = type;

    getDialogTitle(type);
    init();
    if (type !== 'created') {
      this.getFormData(rowData);
    }
    this.drawerVisible = true;
  }

  /*
   *@description:'获取表单数据'
   */
  getFormData(rowData) {
    this.$nextTick(() => {
      this.formData = this.deepClone(rowData);
    });
  }
  /*
   *@description:'确定'
   */
  submitForm() {
    this.formDataRef.validate(async valid => {
      if (valid) {
        if (this.type === 'created') {
          const checkData: any = await checkUserName({ username: this.formData.username });
          if (checkData.userIsUnique) {
            this.submit();
          } else {
            this.$message.warning('登录账号已存在！');
          }
        } else {
          this.submit();
        }
      } else {
        this.setvalidateState('username');
        this.setvalidateState('password');
        this.setvalidateState('fullName');
      }
    });
  }

  submit() {
    const { type } = this;
    this.loading = true;
    const sendFun = type === 'created' ? setUserCreate : setUserUpdate;
    const tipMessage = type === 'created' ? '新增用户成功' : '编辑用户成功';
    this.formData.terminalType = 3;
    sendFun(this.formData)
      .then(res => {
        this.$message.success(tipMessage);
        this.submitSuccessEmit();
        this.drawerVisible = false;
      })
      .catch(err => {
        console.log('err:detailDiaog ', err);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
